/**
 * Tipos compartidos por CategoryReviewPage + hooks. Extraídos como
 * módulo dedicado para mantener la página ≤500L (P7).
 */

export const SOURCE_COLORS: Record<
  string,
  "default" | "primary" | "success" | "warning" | "info"
> = {
  openai: "primary",
  manual: "success",
};

export interface Product {
  id: number;
  unified_product_id: string;
  unified_name: string;
  unified_category: string | null;
  category_source: string | null;
  category_16: string | null;
  category_18: string | null;
  abc_classification: string | null;
  lifecycle_status: string | null;
  llm_response_id: number | null;
  updated_at: string | null;
}

export interface LlmResponseRun {
  id: number;
  task_type: string;
  batch_size: number | null;
  status: string;
  tokens_total: number | null;
  cost_estimate: string | null;
  duration_ms: number | null;
  created_at: string;
  products_linked: number;
}

export interface Summary {
  totalProducts: number;
  classified: number;
  unclassified: number;
  manualCorrections: number;
  byCategory: Record<string, number>;
  bySource: Record<string, number>;
}
